import { createContext, Dispatch, SetStateAction } from "react";

export interface IInviteAudiologistContext {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

const defaultState: IInviteAudiologistContext = {
  open: false,
  setOpen: () => console.warn("InviteAudiologistContext: Not in scope"),
};

export const InviteAudiologistContext = createContext<IInviteAudiologistContext>(defaultState);
